"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { usePlaygroundInitialData } from "#/features/playground/context/PlaygroundInitialDataContext";
import { serverPrefetchMatchesRoute } from "#/features/playground/lib/serverPrefetchMatchesRoute";
import { projectSlice } from "#/features/project/model/projectSlice";
import { usePlaygroundRoute } from "#/shared/hooks/usePlaygroundRoute";
import { useAppDispatch } from "#/store/hooks";

/**
 * Reset the panel loading gate when playground URL segments change
 * (back/forward, <Link>, or programmatic navigations — not only setProject).
 * Skips the initial loadStart when the server already prefetched matching data.
 */
export const usePlaygroundSlugLoadingSync = () => {
  const $ = _c(8);
  const dispatch = useAppDispatch();
  const route = usePlaygroundRoute();
  const serverInitialData = usePlaygroundInitialData();
  let t0;
  if ($[0] !== route?.slug) {
    t0 = route?.slug.join("/") ?? "";
    $[0] = route?.slug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const slugKey = t0;
  const previousSlugKeyRef = useRef(null);
  const isFirstSlugEffectRef = useRef(true);
  let t1;
  let t2;
  if ($[2] !== dispatch || $[3] !== route || $[4] !== serverInitialData || $[5] !== slugKey) {
    t1 = () => {
      if (!route) {
        return;
      }
      if (previousSlugKeyRef.current === slugKey) {
        return;
      }
      const skipInitialLoadStart = isFirstSlugEffectRef.current && serverPrefetchMatchesRoute(serverInitialData, route.slug);
      previousSlugKeyRef.current = slugKey;
      isFirstSlugEffectRef.current = false;
      if (skipInitialLoadStart) {
        return;
      }
      dispatch(projectSlice.actions.loadStart());
    };
    t2 = [dispatch, route, serverInitialData, slugKey];
    $[2] = dispatch;
    $[3] = route;
    $[4] = serverInitialData;
    $[5] = slugKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
};